import React, { useEffect, useState } from 'react'
import { Grid } from '@mui/material'
import { useAppTranslations } from '../../utils/hooks/useAppTranslations'
import { listOption } from './AutoCompleteField'
import { useCompaniesForAutoCompleteLazyQuery } from '../../__generated__/graphql'
import AsyncAutoCompleteField from './AsyncAutoCompleteField'
import { isNil, uniqBy } from 'lodash-es'

const AsyncAutoCompleteCompanies: React.FC = () => {
  const t = useAppTranslations()
  const [queryName, setQueryName] = useState<string>('')
  const [companyList, setCompanyList] = useState<listOption[]>([])
  const [getCompanies, { data: companies }] = useCompaniesForAutoCompleteLazyQuery()

  useEffect(() => {
    getCompanies({
      variables: {
        searchQuery: {
          ...(queryName && { name: queryName.trim() }),
        },
        pagination: { limit: 10, offset: 0 },
      },
    })
  }, [queryName])

  useEffect(() => {
    if (!isNil(companies))
      setCompanyList(
        uniqBy(
          companies.searchCompanies.map((company) => ({
            value: company.id,
            label: company.name,
          })),
          'value'
        )
      )
  }, [companies])

  return (
    <Grid container spacing={3}>
      <Grid size="grow">
        <AsyncAutoCompleteField
          getValue={(value) => setQueryName(value)}
          label={t('commons.companies')}
          name="companyId"
          value={''}
          options={companyList}
        />
      </Grid>
    </Grid>
  )
}

export default AsyncAutoCompleteCompanies
